import {Component} from "@angular/core";
import {keysToTranslate} from 'i18n/keys-to-translate';
import {MenuTreeItem} from "../../core/services/menu/menu-tree-item";
import {AppMenuService} from "../../core/services/menu/app-menu.service";
import {AppConfigService} from "../../core/services/app-config.service";
import {TranslateService} from "@ngx-translate/core";
import {environment} from "../../../environments/environment";
import {AbstractComponent} from "../../shared/components/abstract-component/abstract.component";
import {ImageConfigEntry} from "../../core/base-api";
import {FormatConfigService} from "../../core/services/format-config.service";
import {AppImageConfig} from "../../core/services/app-image-config";
import {LoggingService} from "../../log/logging.service";


@Component({
  selector: 'cap-intercapi-public-dashboard',
  styleUrls: ['./intercapi-public-layout.component.scss'],
  templateUrl: './intercapi-public-layout.component.html'
})
export class IntercapiPublicLayoutComponent extends AbstractComponent {

  private keycloakPasswordChangeUrl: string;
  root: MenuTreeItem;
  private versionInfo: string;

  private imageElementToImagePathMapping: Map<ImageConfigEntry.ElementEnum, string> = new Map();

  imagePath: string;

  constructor(private menuService: AppMenuService,
              private translate: TranslateService,
              private appConfigService: AppConfigService,
              private formatService: FormatConfigService,
              public service: LoggingService) {
    super();
    keysToTranslate<string>([
      'layouts.page.title'
    ]);
    this.addSub(this.menuService.menu$.subscribe((value: MenuTreeItem) => this.root = value));
    this.versionInfo = this.translate.instant('version') + " " + this.translate.instant('layouts.page.title') + " " + this.appConfigService.versionNr;
    this.keycloakPasswordChangeUrl = environment.openIdConnect.issuer + '/account/password';
    this.initAppLogo();
  }

  private initAppLogo() {
    this.imageElementToImagePathMapping.set("APP_LOGO_DEFAULT", '');
    this.imageElementToImagePathMapping.set("APP_LOGO_BE", '');
    this.addSub(this.formatService.imageConfig$.subscribe(config => this.updateLogo(config)));
  }

  private updateLogo(imageConfig: AppImageConfig) {
    if (!imageConfig) {
      return;
    }
    const configuredImageElement = imageConfig.getImageFormatForCurrentLanguage("APP_LOGO");
    if (configuredImageElement && configuredImageElement.element) {
      this.imagePath = this.imageElementToImagePathMapping.get(configuredImageElement.element);
    }
  }

}
